import { render, staticRenderFns } from "./Veterans.vue?vue&type=template&id=1fb51213&scoped=true&"
import script from "./Veterans.vue?vue&type=script&lang=js&"
export * from "./Veterans.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/channel.css?vue&type=style&index=0&id=1fb51213&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb51213",
  null
  
)

export default component.exports